import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=fd418618&scoped=true&"
import script from "./questionDetail.vue?vue&type=script&lang=js&"
export * from "./questionDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionDetail.vue?vue&type=style&index=0&id=fd418618&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd418618",
  null
  
)

export default component.exports